export const DISPLAY_ID_PATTERN = '[A-Z]{4}[2-9A-HJKMNP-Z]{8}';
//# sourceMappingURL=displayId.js.map